import React from 'react';
import { useChatStore } from '../../store/chatStore';
import { X } from 'lucide-react';

import { useTranslation } from 'react-i18next';

interface ChatInformationPreviewProps {
  // No props needed - component manages its own state
}

export const ChatInformationPreview: React.FC<
  ChatInformationPreviewProps
> = () => {
  const { t } = useTranslation('pleri/chat');
  const chatInformation = useChatStore((state) => state.chatInformation);
  const clearChatInformation = useChatStore(
    (state) => state.clearChatInformation,
  );

  if (!chatInformation) {
    return null;
  }

  return (
    <div className="group mb-4">
      <div className="relative">
        {chatInformation}
        <button
          type="button"
          className="absolute top-2 right-2 z-10 inline-flex h-6 w-6 items-center justify-center rounded-full bg-[#FF732E]/80 text-white opacity-0 transition-opacity group-hover:opacity-100 hover:bg-[#FF732E]"
          onClick={(e) => {
            e.stopPropagation();
            clearChatInformation();
          }}
          title={t('clear')}
        >
          <X className="h-3.5 w-3.5" />
        </button>
      </div>
    </div>
  );
};

export default ChatInformationPreview;
